<template>
  <div class="box13">
    <pageTitle title="常见问题" titleColor="#24375C" />

    <commomProblem
      class="box"
      :problemData="problemData"
      :styleData="styleData"
    />
    <div class="btn" @click="zixun('了解更多')">了解更多</div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import commomProblem from "../common/commom-problem.vue";
export default {
  components: {
    pageTitle,
    commomProblem,
  },
  data() {
    return {
      problemData: [
        {
          title: "没有基础可以学会嘛?",
          answer: ["可以，本课程的内容设计与服务项目可满足零基础学员学习。"],
        },
        {
          title: "课程要学习多长时间？",
          answer: [
            "对于脱产学习的同学，如果每天学习5个小时，大概4个月可以完成全套课程的学习。",
          ],
        },
        {
          title: "学完课程可以达到什么水平？",
          answer: [
            "学完本门课程可以达到中高级数据分析师的水平。例如，可以诊断当前公司业务是否正常？业务发展是否达到预期？如果没有达到预期，能够分析出主要问题在哪、是由什么原因导致的。能够预测未来行业的发展，分析竞争对手的业务构成，帮助公司制定战略发展计划，并及时跟踪、分析市场动态等。",
          ],
        },
      ],
      styleData: {
        iconQuestion: require("../../../assets/coursePage/dataAnalysis/box12/icon.png"),
      },
    };
  },
  methods: {
    zixun(name) {
       this.mai("数据开发-就业课","了解更多",0,null)
      // zhuge.track("H5_Web专题页", {
      //   咨询按钮名称: name,
      // });
      this.clickZiXun()
    },
  },
};
</script>

<style lang="scss" scoped>
.box13 {
  padding: 80px 0px 88px;
  width: 100%;
  background: url("../../../assets/coursePage/dataAnalysis/box12/bgc.png")
    no-repeat;
  background-size: cover;
  background-position: top;
  .box {
    margin-top: 48px;
  }
  .btn {
    margin: 0 auto;
    margin-top: 48px;
    width: 686px;
    height: 96px;
    background: linear-gradient(231deg, #6c80fc 0%, #8941fb 100%);
    box-shadow: 0px 4px 12px 0px rgba(64, 255, 189, 0.12);
    border-radius: 48px;
    text-align: center;
    font-size: 30px;
    line-height: 96px;
    font-family: PingFangSC-Medium;
    font-weight: 500;
    color: #ffffff;
  }
}
</style>
